export default __webpack_public_path__ + "static/media/facebook.15d67e98.svg";